export const SaturatedWaterMixTemperature = [
    [0.00611,273.16,0.0010002,206.136,0,2375.3,0.01,2501.4,0,9.1562],
    [0.00813,277.15,0.0010001,157.232,16.77,2380.9,16.78,2508.7,0.061,9.0514],
    [0.00872,278.15,0.0010001,147.12,20.97,2382.3,20.98,2510.6,0.0761,9.0257],
    [0.00935,279.15,0.0010001,137.734,25.19,2383.6,25.2,2512.4,0.0912,9.0003],
    [0.01072,281.15,0.0010002,120.917,33.59,2386.4,33.6,2516.1,0.1212,8.9501],
    [0.01228,283.15,0.0010004,106.379,42,2389.2,42.01,2519.8,0.151,8.9008],
    [0.01312,284.15,0.0010004,99.857,46.2,2390.5,46.2,2521.6,0.1658,8.8765],
    [0.01402,285.15,0.0010005,93.784,50.41,2391.9,50.41,2523.4,0.1806,8.8524],
    [0.01497,286.15,0.0010007,88.124,54.6,2393.3,54.6,2525.3,0.1953,8.8285],
    [0.01598,287.15,0.0010008,82.848,58.79,2394.7,58.8,2527.1,0.2099,8.8048],
    [0.01705,288.15,0.0010009,77.926,62.99,2396.1,62.99,2528.9,0.2245,8.7814],
    [0.01818,289.15,0.0010011,73.333,67.18,2397.4,67.19,2530.8,0.239,8.7582],
    [0.01938,290.15,0.0010012,69.044,71.38,2398.8,71.38,2532.6,0.2535,8.7351],
    [0.02064,291.15,0.0010014,65.038,75.57,2400.2,75.58,2534.4,0.2679,8.7123],
    [0.02198,292.15,0.0010016,61.293,79.76,2401.6,79.77,2536.2,0.2823,8.6897],
    [0.02339,293.15,0.0010018,57.791,83.95,2402.9,83.96,2538.1,0.2966,8.6672],
    [0.02487,294.15,0.001002,54.514,88.14,2404.3,88.14,2539.9,0.3109,8.645],
    [0.02645,295.15,0.0010022,51.447,92.32,2405.7,92.33,2541.7,0.3251,8.6229],
    [0.0281,296.15,0.0010024,48.574,96.51,2407,96.52,2543.5,0.3393,8.6011],
    [0.02985,297.15,0.0010027,45.883,100.7,2408.4,100.7,2545.4,0.3534,8.5794],
    [0.03169,298.15,0.0010029,43.36,104.88,2409.8,104.89,2547.2,0.3674,8.558],
    [0.03363,299.15,0.0010032,40.994,109.06,2411.1,109.07,2549,0.3814,8.5367],
    [0.03567,300.15,0.0010035,38.774,113.25,2412.5,113.25,2550.8,0.3954,8.5156],
    [0.03782,301.15,0.0010037,36.69,117.42,2413.9,117.43,2552.6,0.4093,8.4946],
    [0.04008,302.15,0.001004,34.733,121.6,2415.2,121.61,2554.5,0.4231,8.4739],
    [0.04246,303.15,0.0010043,32.894,125.78,2416.6,125.79,2556.3,0.4369,8.4533],
    [0.04496,304.15,0.0010046,31.165,129.96,2418,129.97,2558.1,0.4507,8.4329],
    [0.04759,305.15,0.001005,29.54,134.14,2419.3,134.15,2559.9,0.4644,8.4127],
    [0.05034,306.15,0.0010053,28.011,138.32,2420.7,138.33,2561.7,0.4781,8.3927],
    [0.05324,307.15,0.0010056,26.571,142.5,2422,142.5,2563.5,0.4917,8.3728],
    [0.05628,308.15,0.001006,25.216,146.67,2423.4,146.68,2565.3,0.5053,8.3531],
    [0.05947,309.15,0.0010063,23.94,150.85,2424.7,150.86,2567.1,0.5188,8.3336],
    [0.06632,311.15,0.0010071,21.602,159.2,2427.4,159.21,2570.7,0.5458,8.295],
    [0.07384,313.15,0.0010078,19.523,167.56,2430.1,167.57,2574.3,0.5725,8.257],
    [0.09593,318.15,0.0010099,15.258,188.44,2436.8,188.45,2583.2,0.6387,8.1648],
    [0.1235,323.15,0.0010121,12.032,209.32,2443.5,209.33,2592.1,0.7038,8.0763],
    [0.1576,328.15,0.0010146,9.568,230.21,2450.1,230.23,2600.9,0.7679,7.9913],
    [0.1994,333.15,0.0010172,7.671,251.11,2456.6,251.13,2609.6,0.8312,7.9096],
    [0.2503,338.15,0.0010199,6.197,272.02,2463.1,272.06,2618.3,0.8935,7.831],
    [0.3119,343.15,0.0010228,5.042,292.95,2469.6,292.98,2626.8,0.9549,7.7553],
    [0.3858,348.15,0.0010259,4.131,313.9,2475.9,313.93,2635.3,1.0155,7.6824],
    [0.4739,353.15,0.0010291,3.407,334.86,2482.2,334.91,2643.7,1.0753,7.6122],
    [0.5783,358.15,0.0010325,2.828,355.84,2488.4,355.9,2651.9,1.1343,7.5445],
    [0.7014,363.15,0.001036,2.361,376.85,2494.5,376.92,2660.1,1.1925,7.4791],
    [0.8455,368.15,0.0010397,1.982,397.88,2500.6,397.96,2668.1,1.25,7.4159],
    [1.014,373.15,0.0010435,1.673,418.94,2506.5,419.04,2676.1,1.3069,7.3549],
    [1.433,383.15,0.0010516,1.21,461.14,2518.1,461.3,2691.5,1.4185,7.2387],
    [1.985,393.15,0.0010603,0.8919,503.5,2529.3,503.71,2706.3,1.5276,7.1296],
    [2.701,403.15,0.0010697,0.6685,546.02,2539.9,546.31,2720.5,1.6344,7.0269],
    [3.613,413.15,0.0010797,0.5089,588.74,2550,589.13,2733.9,1.7391,6.9299],
    [4.758,423.15,0.0010905,0.3928,631.68,2559.5,632.2,2746.5,1.8418,6.8379],
    [6.178,433.15,0.0011020,0.3071,674.86,2568.4,675.55,2758.1,1.9427,6.7502],
    [7.917,443.15,0.0011143,0.2428,718.33,2576.5,719.21,2768.7,2.0419,6.6663],
    [10.02,453.15,0.0011274,0.1941,762.09,2583.7,763.22,2778.2,2.1396,6.5857],
    [12.54,463.15,0.0011414,0.1565,806.19,2590,807.62,2786.4,2.2359,6.5079],
    [15.54,473.15,0.0011565,0.1274,850.65,2595.3,852.45,2793.2,2.3309,6.4323],
    [19.06,483.15,0.0011726,0.1044,895.53,2599.5,897.76,2798.5,2.4248,6.3585],
    [23.18,493.15,0.00119,0.08619,940.87,2602.4,943.62,2802.1,2.5178,6.2861],
    [27.95,503.15,0.0012088,0.07158,986.74,2603.9,990.12,2804,2.6099,6.2146],
    [33.44,513.15,0.0012291,0.05976,1033.2,2604,1037.3,2803.8,2.7015,6.1437],
    [39.73,523.15,0.0012512,0.05013,1080.4,2602.4,1085.4,2801.5,2.7927,6.073],
    [46.88,533.15,0.0012755,0.04221,1128.4,2599,1134.4,2796.6,2.8838,6.0019],
    [54.99,543.15,0.0013023,0.03564,1177.4,2593.7,1184.5,2789.7,2.9751,5.9301],
    [64.12,553.15,0.0013321,0.03017,1227.5,2586.1,1236,2779.6,3.0668,5.8571],
    [74.36,563.15,0.0013656,0.02557,1278.9,2576,1289.1,2766.2,3.1594,5.7821],
    [85.81,573.15,0.0014036,0.02167,1332,2563,1344,2749,3.2534,5.7045],
    [112.7,593.15,0.0014988,0.01549,1444.6,2525.5,1461.5,2700.1,3.448,5.5362],
    [145.9,613.15,0.0016379,0.0108,1570.3,2464.6,1594.2,2622,3.6594,5.3357],
    [186.5,633.15,0.0018925,0.006945,1725.2,2351.5,1760.5,2481,3.9147,5.0526],
    [220.9,647.29,0.003155,0.003155,2029.6,2029.6,2099.3,2099.3,4.4298,4.4298],
];

export const SaturatedWaterMixPressure = [
    [0.04,302.11,0.001004,34.8,121.45,2415.2,121.46,2554.4,0.4226,8.4746],
    [0.06,309.31,0.0010064,23.739,151.53,2425,151.53,2567.4,0.521,8.3304],
    [0.08,314.66,0.0010084,18.103,173.87,2432.2,173.88,2577,0.5926,8.2287],
    [0.1,318.96,0.0010102,14.674,191.82,2437.9,191.83,2584.7,0.6493,8.1502],
    [0.2,333.21,0.0010172,7.649,251.38,2456.7,251.4,2609.7,0.832,7.9085],
    [0.3,342.25,0.0010223,5.229,289.2,2468.4,289.23,2625.3,0.9439,7.7686],
    [0.4,349.02,0.0010265,3.993,317.53,2477,317.58,2636.8,1.0259,7.67],
    [0.5,354.48,0.00103,3.24,340.44,2483.9,340.49,2645.9,1.091,7.5939],
    [0.6,359.09,0.0010331,2.732,359.79,2489.6,359.86,2653.5,1.1453,7.532],
    [0.7,363.1,0.001036,2.365,376.63,2494.5,376.7,2660,1.1919,7.4797],
    [0.8,366.65,0.001038,2.087,391.58,2498.8,391.66,2665.8,1.2329,7.4346],
    [0.9,369.86,0.001041,1.869,405.06,2502.6,405.15,2670.9,1.2695,7.3949],
    [1,372.78,0.0010432,1.694,417.36,2506.1,417.46,2675.5,1.3026,7.3594],
    [1.5,384.55,0.0010528,1.159,466.94,2519.7,467.11,2693.6,1.4336,7.2233],
    [2,393.35,0.0010605,0.8857,504.49,2529.5,504.7,2706.7,1.5301,7.1271],
    [2.5,400.55,0.0010672,0.7187,535.1,2537.2,535.37,2716.9,1.6072,7.0527],
    [3,406.75,0.0010732,0.6058,561.15,2543.6,561.47,2725.3,1.6718,6.9919],
    [3.5,412.05,0.0010786,0.5243,583.95,2546.9,584.33,2732.4,1.7275,6.9405],
    [4,416.75,0.0010836,0.4625,604.31,2553.6,604.74,2738.6,1.7766,6.8959],
    [4.5,421.05,0.0010882,0.414,622.25,2557.6,623.25,2743.9,1.8207,6.8565],
    [5,425.05,0.0010926,0.3749,639.68,2561.2,640.23,2748.7,1.8607,6.8212],
    [6,432.05,0.0011006,0.3157,669.9,2567.4,670.56,2756.8,1.9312,6.76],
    [7,438.15,0.001108,0.2729,696.44,2572.5,697.22,2763.5,1.9922,6.708],
    [8,443.55,0.0011148,0.2404,720.22,2576.8,721.11,2769.1,2.0462,6.6628],
    [9,448.55,0.0011212,0.215,741.83,2580.5,742.83,2773.9,2.0946,6.6226],
    [10,453.05,0.0011273,0.1944,761.68,2583.6,762.81,2778.1,2.1387,6.5863],
    [15,471.45,0.0011539,0.1318,843.16,2594.5,844.84,2792.2,2.315,6.4448],
    [20,485.55,0.0011767,0.09963,906.44,2600.3,908.79,2799.5,2.4474,6.3409],
    [25,497.15,0.0011973,0.07998,959.11,2603.1,962.11,2803.1,2.5547,6.2575],
    [30,507.05,0.0012165,0.06668,1004.8,2604.1,1008.4,2804.2,2.6457,6.1869],
    [35,515.75,0.0012347,0.05707,1045.4,2603.7,1049.8,2803.4,2.7253,6.1253],
    [40,523.55,0.0012522,0.04978,1082.3,2602.3,1087.3,2801.4,2.7964,6.0701],
    [45,530.65,0.0012692,0.04406,1116.2,2600.1,1121.9,2798.3,2.861,6.0199],
    [50,537.15,0.0012859,0.03944,1147.8,2597.1,1154.2,2794.3,2.9202,5.9734],
    [60,548.75,0.0013187,0.03244,1205.4,2589.7,1213.4,2784.3,3.0267,5.8892],
    [70,559.05,0.0013513,0.02737,1257.6,2580.5,1267,2772.1,3.1211,5.8133],
    [80,568.25,0.0013842,0.02352,1305.6,2569.8,1316.6,2758,3.2068,5.7432],
    [90,576.55,0.0014178,0.02048,1350.5,2557.8,1363.3,2742.1,3.2858,5.6772],
    [100,584.25,0.0014524,0.01803,1393,2544.4,1407.6,2724.7,3.3596,5.6141],
    [110,591.35,0.0014886,0.01599,1433.7,2529.8,1450.1,2705.6,3.4295,5.5527],
    [120,597.95,0.0015267,0.01426,1473,2513.7,1491.3,2684.9,3.4962,5.4924],
    [130,604.05,0.0015671,0.01278,1511.1,2496.1,1531.5,2662.2,3.5606,5.4323],
    [140,609.95,0.0016107,0.01149,1548.6,2476.8,1571.1,2637.6,3.6232,5.3717],
    [150,615.35,0.0016581,0.01034,1585.6,2455.5,1610.5,2610.5,3.6848,5.3098],
    [160,620.55,0.0017107,0.009306,1622.7,2431.7,1650.1,2580.6,3.7461,5.2455],
    [170,625.55,0.0017702,0.008364,1660.2,2405,1690.3,2547.2,3.8079,5.1777],
    [180,630.25,0.0018397,0.007489,1698.9,2374.3,1732,2509.1,3.8715,5.1044],
    [190,634.65,0.0019243,0.006657,1739.9,2338.1,1776.5,2464.5,3.9388,5.0228],
    [200,638.95,0.002036,0.005834,1785.6,2293,1826.3,2409.7,4.0139,4.9269],
    [220.9,647.25,0.003155,0.003155,2029.6,2029.6,2099.3,2099.3,4.4298,4.4298],
];

export const SubcooledWater = [
    [25,293.15,1.0006,83.8,86.3,0.2961],
    [25,313.15,1.0067,167.25,169.77,0.5715],
    [25,353.15,1.028,334.29,336.86,1.0737],
    [25,373.15,1.0423,418.24,420.85,1.305],
    [25,413.15,1.0784,587.82,590.52,1.7369],
    [25,453.15,1.1261,761.16,763.97,2.1375],
    [25,473.15,1.1555,849.9,852.8,2.3294],
    [25,493.15,1.1898,940.7,943.7,2.5174],
    [25,497.14,1.1973,959.1,962.1,2.5546],
    [50,293.15,0.9995,83.65,88.65,0.2956],
    [50,313.15,1.0056,166.95,171.97,0.5705],
    [50,353.15,1.0268,333.72,338.85,1.072],
    [50,373.15,1.041,417.52,422.72,1.303],
    [50,413.15,1.0768,586.76,592.15,1.7343],
    [50,453.15,1.124,759.63,765.25,2.1341],
    [50,473.15,1.153,848.1,853.9,2.3255],
    [50,493.15,1.1866,938.4,944.4,2.5128],
    [50,537.14,1.2859,1147.8,1154.2,2.9202],
    [75,293.15,0.9984,83.5,90.99,0.295],
    [75,313.15,1.0045,166.64,174.18,0.5696],
    [75,353.15,1.0256,333.15,340.84,1.0704],
    [75,373.15,1.0397,416.81,424.62,1.3011],
    [75,413.15,1.0752,585.72,593.78,1.7317],
    [75,453.15,1.1219,758.13,766.55,2.1308],
    [75,493.15,1.1835,936.2,945.1,2.5083],
    [75,533.15,1.2696,1124.4,1134,2.8763],
    [75,563.74,1.3677,1282,1292.2,3.1649],
    [100,293.15,0.9972,83.36,93.33,0.2945],
    [100,313.15,1.0034,166.35,176.38,0.5686],
    [100,353.15,1.0245,332.59,342.83,1.0688],
    [100,373.15,1.0385,416.12,426.5,1.2992],
    [100,413.15,1.0737,584.68,595.42,1.7292],
    [100,453.15,1.1199,756.65,767.84,2.1275],
    [100,493.15,1.1805,934.1,945.9,2.5039],
    [100,533.15,1.2645,1121.1,1133.7,2.8699],
    [100,584.21,1.4524,1393,1407.6,3.3596],
    [150,293.15,0.995,83.06,97.99,0.2934],
    [150,313.15,1.0013,165.76,180.78,0.5666],
    [150,353.15,1.0222,331.48,346.81,1.0656],
    [150,373.15,1.0361,414.74,430.28,1.2955],
    [150,413.15,1.0707,582.66,598.72,1.7242],
    [150,453.15,1.1159,753.76,770.5,2.121],
    [150,493.15,1.1748,929.9,947.5,2.4953],
    [150,533.15,1.255,1114.6,1133.4,2.8576],
    [150,573.15,1.377,1316.6,1337.3,3.226],
    [150,615.39,1.6581,1585.6,1610.5,3.6848],
    [200,293.15,0.9928,82.77,102.62,0.2923],
    [200,313.15,0.9992,165.17,185.16,0.5646],
    [200,353.15,1.0199,330.4,350.8,1.0624],
    [200,373.15,1.0337,413.39,434.06,1.2917],
    [200,413.15,1.0678,580.69,602.04,1.7193],
    [200,453.15,1.112,750.95,773.2,2.1147],
    [200,493.15,1.1693,925.9,949.3,2.487],
    [200,533.15,1.2462,1108.6,1133.5,2.8459],
    [200,573.15,1.3596,1306.1,1333.3,3.2071],
    [200,638.96,2.036,1785.6,1826.3,4.0139],
    [250,293.15,0.9907,82.47,107.24,0.2911],
    [250,313.15,0.9971,164.6,189.52,0.5626],
    [250,373.15,1.0313,412.08,437.85,1.2881],
    [250,473.15,1.1344,834.5,862.8,2.2961],
    [250,573.15,1.3442,1296.6,1330.2,3.19],
    [300,293.15,0.9886,82.17,111.84,0.2899],
    [300,313.15,0.9951,164.04,193.89,0.5607],
    [300,373.15,1.029,410.78,441.66,1.2844],
    [300,473.15,1.1302,831.4,865.3,2.2893],
    [300,573.15,1.3304,1287.9,1327.8,3.1741],
];

export const SuperheatedSteam = [
    [0.06,309.31,23.739,2425,2567.4,8.3304],
    [0.06,353.15,27.132,2487.3,2650.1,8.5804],
    [0.06,393.15,30.219,2544.7,2726,8.784],
    [0.06,433.15,33.302,2602.7,2802.5,8.9693],
    [0.06,473.15,36.383,2661.4,2879.7,9.1398],
    [0.06,513.15,39.462,2721,2957.8,9.2982],
    [0.06,553.15,42.54,2781.5,3036.8,9.4464],
    [0.06,593.15,45.618,2843,3116.7,9.5859],
    [0.06,633.15,48.696,2905.5,3197.7,9.718],
    [0.06,673.15,51.774,2969,3279.6,9.8435],
    [0.06,713.15,54.851,3033.5,3362.6,9.9633],
    [0.06,773.15,59.467,3132.3,3489.1,10.1336],
    [0.35,345.84,4.526,2473,2631.4,7.7158],
    [0.35,353.15,4.625,2483.7,2645.6,7.7564],
    [0.35,393.15,5.163,2542.4,2723.1,7.9644],
    [0.35,433.15,5.696,2601.2,2800.6,8.1519],
    [0.35,473.15,6.228,2660.4,2878.4,8.3237],
    [0.35,513.15,6.758,2720.3,2956.8,8.4828],
    [0.35,553.15,7.287,2780.9,3036,8.6314],
    [0.35,593.15,7.815,2842.5,3116.1,8.7712],
    [0.35,633.15,8.344,2905.1,3197.1,8.9034],
    [0.35,673.15,8.872,2968.6,3279.2,9.0291],
    [0.35,713.15,9.4,3033.2,3362.2,9.149],
    [0.35,773.15,10.192,3132.1,3488.8,9.3194],
    [0.7,363.1,2.365,2494.5,2660,7.4797],
    [0.7,373.15,2.434,2509.7,2680,7.5341],
    [0.7,393.15,2.571,2539.7,2719.6,7.6375],
    [0.7,433.15,2.841,2599.4,2798.2,7.8279],
    [0.7,473.15,3.108,2659.1,2876.7,8.0012],
    [0.7,513.15,3.374,2719.3,2955.5,8.1611],
    [0.7,553.15,3.64,2780.2,3035,8.3162],
    [0.7,593.15,3.905,2842,3115.3,8.4504],
    [0.7,633.15,4.17,2904.6,3196.5,8.5828],
    [0.7,673.15,4.434,2968.2,3278.6,8.7086],
    [0.7,713.15,4.698,3032.9,3361.8,8.8286],
    [0.7,773.15,5.095,3131.8,3488.5,8.9991],
    [1,372.78,1.694,2506.1,2675.5,7.3594],
    [1,373.15,1.696,2506.7,2676.2,7.3614],
    [1,393.15,1.793,2537.3,2716.6,7.4668],
    [1,433.15,1.984,2597.8,2796.2,7.6597],
    [1,473.15,2.172,2658.1,2875.3,7.8343],
    [1,513.15,2.359,2718.5,2954.5,7.9949],
    [1,553.15,2.546,2779.6,3034.2,8.1445],
    [1,593.15,2.732,2841.5,3114.6,8.2849],
    [1,633.15,2.917,2904.2,3195.9,8.4175],
    [1,673.15,3.103,2967.9,3278.2,8.5435],
    [1,713.15,3.288,3032.6,3361.4,8.6636],
    [1,773.15,3.565,3131.6,3488.1,8.8342],
    [1.5,384.52,1.159,2519.7,2693.6,7.2233],
    [1.5,393.15,1.188,2533.3,2711.4,7.2693],
    [1.5,433.15,1.317,2595.2,2792.8,7.4665],
    [1.5,473.15,1.444,2656.2,2872.9,7.6433],
    [1.5,513.15,1.57,2717.2,2952.7,7.8052],
    [1.5,553.15,1.695,2778.6,3032.8,7.9555],
    [1.5,593.15,1.819,2840.6,3113.5,8.0964],
    [1.5,633.15,1.943,2903.5,3195,8.2293],
    [1.5,673.15,2.067,2967.3,3277.4,8.3555],
    [1.5,713.15,2.191,3032.1,3360.7,8.4757],
    [1.5,773.15,2.376,3131.2,3487.6,8.6466],
    [1.5,873.15,2.685,3301.7,3704.3,8.9101],
    [3,406.7,0.606,2543.6,2725.3,6.9919],
    [3,433.15,0.651,2587.1,2782.3,7.1276],
    [3,473.15,0.716,2650.7,2865.5,7.3115],
    [3,513.15,0.781,2713.1,2947.3,7.4774],
    [3,553.15,0.844,2775.4,3028.6,7.6299],
    [3,593.15,0.907,2838.1,3110.1,7.7722],
    [3,633.15,0.969,2901.4,3192.2,7.9061],
    [3,673.15,1.032,2965.6,3275,8.033],
    [3,713.15,1.094,3030.6,3358.7,8.1538],
    [3,773.15,1.187,3130,3486,8.3251],
    [3,873.15,1.341,3300.8,3703.2,8.5892],
    [5,425.01,0.3749,2561.2,2748.7,6.8213],
    [5,453.15,0.4045,2609.7,2812,6.9656],
    [5,473.15,0.4249,2642.9,2855.4,7.0592],
    [5,513.15,0.4646,2707.6,2939.9,7.2307],
    [5,553.15,0.5034,2771.2,3022.9,7.3865],
    [5,593.15,0.5416,2834.7,3105.6,7.5308],
    [5,633.15,0.5796,2898.7,3188.4,7.666],
    [5,673.15,0.6173,2963.2,3271.9,7.7938],
    [5,713.15,0.6548,3028.6,3356,7.9152],
    [5,773.15,0.7109,3128.4,3483.9,8.0873],
    [5,873.15,0.8041,3299.6,3701.7,8.3522],
    [5,973.15,0.8969,3477.5,3925.9,8.5952],
    [7,438.12,0.2729,2572.5,2763.5,6.708],
    [7,453.15,0.2847,2599.8,2799.1,6.788],
    [7,473.15,0.2999,2634.8,2844.8,6.8865],
    [7,513.15,0.3292,2701.8,2932.2,7.0641],
    [7,553.15,0.3574,2766.9,3017.1,7.2233],
    [7,593.15,0.3852,2831.3,3100.9,7.3697],
    [7,633.15,0.4126,2895.8,3184.7,7.5063],
    [7,673.15,0.4397,2960.9,3268.7,7.635],
    [7,713.15,0.4667,3026.6,3353.3,7.7571],
    [7,773.15,0.507,3126.8,3481.7,7.9299],
    [7,873.15,0.5738,3298.5,3700.2,8.1956],
    [7,973.15,0.6403,3476.6,3924.8,8.4391],
    [10,453.06,0.1944,2583.6,2778.1,6.5865],
    [10,473.15,0.206,2621.9,2827.9,6.694],
    [10,513.15,0.2275,2692.9,2920.4,6.8817],
    [10,553.15,0.248,2760.2,3008.2,7.0465],
    [10,593.15,0.2678,2826.1,3093.9,7.1962],
    [10,633.15,0.2873,2891.6,3178.9,7.3349],
    [10,673.15,0.3066,2957.3,3263.9,7.4651],
    [10,713.15,0.3257,3023.6,3349.3,7.5883],
    [10,773.15,0.3541,3124.4,3478.5,7.7622],
    [10,813.15,0.3729,3192.6,3565.6,7.872],
    [10,873.15,0.4011,3296.8,3697.9,8.029],
    [10,913.15,0.4198,3367.4,3787.2,8.129],
    [15,471.47,0.1318,2594.5,2792.2,6.4448],
    [15,473.15,0.1325,2598.1,2796.8,6.4546],
    [15,513.15,0.1483,2676.9,2899.3,6.6628],
    [15,553.15,0.1627,2748.6,2992.7,6.8381],
    [15,593.15,0.1765,2817.1,3081.9,6.9938],
    [15,633.15,0.1899,2884.4,3169.2,7.1363],
    [15,673.15,0.203,2951.3,3255.8,7.269],
    [15,713.15,0.216,3018.5,3342.5,7.394],
    [15,773.15,0.2352,3120.3,3473.1,7.5698],
    [15,813.15,0.2478,3189.1,3560.9,7.6805],
    [15,873.15,0.2668,3293.9,3694,7.8385],
    [15,913.15,0.2793,3364.8,3783.8,7.9391],
    [20,485.57,0.0996,2600.3,2799.5,6.3409],
    [20,513.15,0.1085,2659.6,2876.5,6.4952],
    [20,553.15,0.12,2736.4,2976.4,6.6828],
    [20,593.15,0.1308,2807.9,3069.5,6.8452],
    [20,633.15,0.1411,2877,3159.3,6.9917],
    [20,673.15,0.1512,2945.2,3247.6,7.1271],
    [20,713.15,0.1611,3013.4,3335.5,7.254],
    [20,773.15,0.1757,3116.2,3467.6,7.4317],
    [20,813.15,0.1853,3185.6,3556.1,7.5434],
    [20,873.15,0.1996,3290.9,3690.1,7.7024],
    [20,913.15,0.2091,3362.2,3780.4,7.8035],
    [20,973.15,0.2232,3470.9,3917.4,7.9487],
    [30,507.05,0.0667,2604.1,2804.2,6.1869],
    [30,513.15,0.0682,2619.7,2824.3,6.2265],
    [30,553.15,0.0771,2709.9,2941.3,6.4462],
    [30,593.15,0.085,2788.4,3043.4,6.6245],
    [30,633.15,0.0923,2861.7,3138.7,6.7801],
    [30,673.15,0.0994,2932.8,3230.9,6.9212],
    [30,713.15,0.1062,3002.9,3321.5,7.052],
    [30,773.15,0.1162,3108,3456.5,7.2338],
    [30,813.15,0.1227,3178.4,3546.6,7.3474],
    [30,873.15,0.1324,3285,3682.3,7.5085],
    [30,913.15,0.1388,3357,3773.5,7.6106],
    [30,973.15,0.1484,3466.5,3911.7,7.7571],
    [40,523.55,0.04978,2602.3,2801.4,6.0701],
    [40,553.15,0.05546,2680,2901.8,6.2568],
    [40,593.15,0.06199,2767.4,3015.4,6.4553],
    [40,633.15,0.06788,2845.7,3117.2,6.6215],
    [40,673.15,0.07341,2919.9,3213.6,6.769],
    [40,713.15,0.07872,2992.2,3307.1,6.9041],
    [40,773.15,0.08643,3099.5,3445.3,7.0901],
    [40,813.15,0.09145,3171.1,3536.9,7.2056],
    [40,873.15,0.09885,3279.1,3674.4,7.3688],
    [40,913.15,0.1037,3351.8,3766.6,7.472],
    [40,973.15,0.111,3462.1,3905.9,7.6198],
    [40,1013.15,0.1157,3536.6,3999.6,7.7141],
    [60,548.79,0.03244,2589.7,2784.3,5.8892],
    [60,553.15,0.03317,2605.2,2804.2,5.9252],
    [60,593.15,0.03876,2720,2952.6,6.1846],
    [60,633.15,0.04331,2811.2,3071.1,6.3782],
    [60,673.15,0.04739,2892.9,3177.2,6.5408],
    [60,713.15,0.05122,2970,3277.3,6.6853],
    [60,773.15,0.05665,3082.2,3422.2,6.8803],
    [60,813.15,0.06015,3156.1,3517,6.9999],
    [60,873.15,0.06525,3266.9,3658.4,7.1677],
    [60,913.15,0.06859,3341,3752.6,7.2731],
    [60,973.15,0.07352,3453.1,3894.1,7.4234],
    [60,1013.15,0.07677,3528.3,3989.2,7.519],
    [80,568.21,0.02352,2569.8,2758,5.7432],
    [80,593.15,0.02682,2662.7,2877.2,5.9489],
    [80,633.15,0.03089,2772.7,3019.8,6.1819],
    [80,673.15,0.03432,2863.8,3138.3,6.3634],
    [80,713.15,0.03742,2946.7,3246.1,6.519],
    [80,753.15,0.04034,3025.7,3348.4,6.6586],
    [80,793.15,0.04313,3102.7,3447.7,6.7871],
    [80,833.15,0.04582,3178.7,3545.3,6.9072],
    [80,873.15,0.04845,3254.4,3642,7.0206],
    [80,913.15,0.05102,3330.1,3738.3,7.1283],
    [80,973.15,0.05481,3443.9,3882.4,7.2812],
    [80,1013.15,0.05729,3520.4,3978.7,7.3782],
    [100,584.21,0.01803,2544.4,2724.7,5.6141],
    [100,593.15,0.01925,2588.8,2781.3,5.7103],
    [100,633.15,0.02331,2729.1,2962.1,6.006],
    [100,673.15,0.02641,2832.4,3096.5,6.212],
    [100,713.15,0.02911,2922.1,3213.2,6.3805],
    [100,753.15,0.0316,3005.4,3321.4,6.5282],
    [100,793.15,0.03394,3085.6,3425.1,6.6622],
    [100,833.15,0.03619,3164.1,3526,6.7864],
    [100,873.15,0.03837,3241.7,3625.3,6.9029],
    [100,913.15,0.04048,3318.9,3723.7,7.0131],
    [100,973.15,0.04358,3434.7,3870.5,7.1687],
    [100,1013.15,0.0456,3512.1,3968.1,7.267],
    [120,597.9,0.01426,2513.7,2684.9,5.4924],
    [120,633.15,0.01811,2678.4,2895.7,5.8361],
    [120,673.15,0.02108,2798.3,3051.3,6.0747],
    [120,713.15,0.02355,2896.1,3178.7,6.2586],
    [120,753.15,0.02576,2984.4,3293.5,6.4154],
    [120,793.15,0.02781,3068,3401.8,6.5555],
    [120,833.15,0.02977,3149,3506.2,6.684],
    [120,873.15,0.03164,3228.7,3608.3,6.8037],
    [120,913.15,0.03345,3307.5,3709,6.9164],
    [120,973.15,0.0361,3425.2,3858.4,7.0749],
    [120,1013.15,0.03781,3503.7,3957.4,7.1746],
    [140,609.9,0.01149,2476.8,2637.6,5.3717],
    [140,633.15,0.01422,2617.4,2816.5,5.6602],
    [140,673.15,0.01722,2760.9,3001.9,5.9448],
    [140,713.15,0.01954,2868.6,3142.2,6.1474],
    [140,753.15,0.02157,2962.5,3264.5,6.3143],
    [140,793.15,0.02343,3049.8,3377.8,6.461],
    [140,833.15,0.02517,3133.6,3486,6.5941],
    [140,873.15,0.02683,3215.4,3591.1,6.7172],
    [140,913.15,0.02843,3296,3694.1,6.8326],
    [140,973.15,0.03075,3415.7,3846.2,6.9939],
    [140,1013.15,0.03225,3495.2,3946.7,7.0952],
    [160,620.59,0.00931,2431.7,2580.6,5.2455],
    [160,633.15,0.01105,2539,2715.8,5.4614],
    [160,673.15,0.01426,2719.4,2947.6,5.8175],
    [160,713.15,0.01652,2839.4,3103.7,6.0429],
    [160,753.15,0.01842,2939.7,3234.4,6.2215],
    [160,793.15,0.02013,3031.1,3353.3,6.3752],
    [160,833.15,0.02172,3117.8,3465.4,6.5132],
    [160,873.15,0.02323,3201.8,3573.5,6.6399],
    [160,913.15,0.02467,3284.2,3678.9,6.758],
    [160,973.15,0.02674,3406,3833.9,6.9224],
    [160,1013.15,0.02808,3486.7,3935.9,7.0251],
    [180,630.21,0.00749,2374.3,2509.1,5.1044],
    [180,633.15,0.00809,2418.9,2564.5,5.1922],
    [180,673.15,0.0119,2672.8,2887,5.6887],
    [180,713.15,0.01414,2808.2,3062.8,5.9428],
    [180,753.15,0.01596,2915.9,3203.2,6.1345],
    [180,793.15,0.01757,3011.8,3378,6.296],
    [180,833.15,0.01904,3101.7,3444.4,6.4392],
    [180,873.15,0.02042,3188,3555.6,6.5696],
    [180,913.15,0.02174,3272.3,3663.6,6.6905],
    [180,973.15,0.02362,3396.3,3821.5,6.858],
    [180,1013.15,0.02483,3478,3925,6.9623],
    [200,638.96,0.00583,2293,2409.7,4.9269],
    [200,673.15,0.00994,2619.3,2818.1,5.554],
    [200,713.15,0.01222,2774.9,3019.4,5.845],
    [200,753.15,0.01399,2891.2,3170.8,6.0518],
    [200,793.15,0.01551,2992,3302.2,6.2218],
    [200,833.15,0.01689,3085.2,3423,6.3705],
    [200,873.15,0.01818,3174,3537.6,6.5048],
    [200,913.15,0.0194,3260.2,3648.1,6.6286],
    [200,973.15,0.02113,3386.4,3809,6.7993],
    [200,1013.15,0.02224,3469.3,3914.1,6.9052],
    [200,1073.15,0.02385,3592.7,4069.7,7.0544],
    [240,673.15,0.00673,2477.8,2639.4,5.2393],
    [240,713.15,0.00929,2700.6,2923.4,5.6506],
    [240,753.15,0.011,2838.3,3102.3,5.895],
    [240,793.15,0.01241,2950.5,3248.5,6.0842],
    [240,833.15,0.01366,3051.1,3379,6.2448],
    [240,873.15,0.01481,3145.2,3500.7,6.3875],
    [240,913.15,0.01588,3235.5,3616.7,6.5174],
    [240,973.15,0.01739,3366.4,3783.8,6.6947],
    [240,1013.15,0.01835,3451.7,3892.1,6.8038],
    [240,1073.15,0.01974,3578,4051.6,6.9567],
    [280,673.15,0.00383,2223.5,2330.7,4.7494],
    [280,713.15,0.00712,2613.2,2812.6,5.4494],
    [280,753.15,0.00885,2780.8,3028.5,5.7446],
    [280,793.15,0.0102,2906.8,3192.3,5.9566],
    [280,833.15,0.01136,3015.7,3333.7,6.1307],
    [280,873.15,0.01241,3115.6,3463,6.2823],
    [280,913.15,0.01338,3210.3,3584.8,6.4187],
    [280,973.15,0.01473,3346.1,3758.4,6.6029],
    [280,1013.15,0.01558,3433.9,3870,6.7153],
    [280,1073.15,0.0168,3563.1,4033.4,6.872],
    [280,1173.15,0.01873,3774.3,4298.8,7.1084],
    [320,673.15,0.00236,1980.4,2055.9,4.3239],
    [320,713.15,0.00544,2509,2683,5.2327],
    [320,753.15,0.00722,2718.1,2949.2,5.5968],
    [320,793.15,0.00853,2860.7,3133.7,5.8357],
    [320,833.15,0.00963,2979,3287.2,6.0246],
    [320,873.15,0.01061,3085.3,3424.6,6.1858],
    [320,913.15,0.0115,3184.5,3552.5,6.329],
    [320,973.15,0.01273,3325.4,3732.8,6.5203],
    [320,1013.15,0.0135,3415.9,3847.8,6.6361],
    [320,1073.15,0.0146,3548,4015.1,6.7966],
    [320,1173.15,0.01633,3762.7,4285.1,7.0372],
];
